import { render } from "./QuestVictory01.vue?vue&type=template&id=b51e874e"
import script from "./QuestVictory01.vue?vue&type=script&lang=js"
export * from "./QuestVictory01.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/questVictories/QuestVictory01.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b51e874e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b51e874e', __exports__)) {
    api.reload('b51e874e', __exports__)
  }
  
  module.hot.accept("./QuestVictory01.vue?vue&type=template&id=b51e874e", () => {
    api.rerender('b51e874e', render)
  })

}


export default __exports__